import { useEffect, useState } from "react";

const POLL_INTERVAL_MS = 30_000;
const POLL_DURATION_MS = 150_000;

export function usePullQuotesPolling() {
  const [refetchInterval, setRefetchInterval] = useState<number | false>(false);

  useEffect(() => {
    const pullQuotes = new URLSearchParams(window.location.search).get("pull_quotes");
    if (pullQuotes !== "true") return;

    setRefetchInterval(POLL_INTERVAL_MS);
    const timeout = setTimeout(() => setRefetchInterval(false), POLL_DURATION_MS);
    return () => clearTimeout(timeout);
  }, []);

  return refetchInterval;
}
